import { useEffect } from "react";
import { scrollTop } from "../../components/Helper";

const Disclaimer = () => {
	useEffect(() => {
		scrollTop();
	}, []);
	return (
		<div className="col-lg-12">
			<div className="card overflow-hidden">
				<div className="card-header p-0 overflow-hidden">
					<div className="about-header">Disclaimer</div>
				</div>
				<div className="card-body bg-white p-1 body-minh">
					<div className="row">
						<div className="col-12">
							<h5 className="bg-light py-2">Disclaimer</h5>
							<p>
								If you see any copy righted data please bring it to our notice at info@nris.com we will take action in no time, And all the components in our site are patent
								pending ideas with patent number NY/PN8PT/177880YN, copying the designs, data and ideas from this website is liable for lawsuit.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Disclaimer;
